import React, { type FunctionComponent } from 'react'
import { Text, colors, spacing } from '@retailer-platform/shared-components'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { MerchandisingFormInput } from 'domains/merchandising/components/form-input/MerchandisingFormInput'
import { MerchandisingFormSelect } from 'domains/merchandising/components/form-input/MerchandisingFormSelect'
import { placementExperimentMethodOptions } from 'domains/banners/constants/banner.constants'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { useSelectOptionsDashMessage } from 'domains/merchandising/utils/intl.hooks'
import { useDashMessage } from 'intl/intl.hooks'
import { PlacementExperimentMethodEnum } from 'domains/merchandising/api'

interface Props extends Omit<ControllerProps, 'name'> {}

const footnoteWrapper = {
  margin: `-${spacing.X12} 0 ${spacing.X16} 0`,
}

const footnoteStyles = {
  color: colors.GRAYSCALE.X70,
  margin: 0,
}

export const BannerFormExperiment: FunctionComponent<Props> = ({ form }) => {
  const { register, getValues, watch, setValue } = form
  const experimentMethod: string =
    watch('experiment.accessMethod') || PlacementExperimentMethodEnum.ExperimentMethodUnspecified

  const footnote = useDashMessage(
    'bannersDomain.bannersForm.form.section.content.experiment.footnote'
  )

  const accessMethodOptions = useSelectOptionsDashMessage(placementExperimentMethodOptions)

  return (
    <MerchandisingFormSection
      titleId="bannersDomain.bannersForm.form.section.content.experiment.title"
      tooltipId="bannersDomain.bannersForm.form.section.content.experiment.tooltip"
      renderAction
    >
      <MerchandisingFormRow>
        <MerchandisingFormField fullWidth>
          <MerchandisingFormInput
            identifier="experiment.name"
            defaultValue={getValues('experiment.name')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.experiment.name.label"
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="experiment.variant"
            defaultValue={getValues('experiment.variant')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.experiment.variant.label"
          />
        </MerchandisingFormField>

        <MerchandisingFormField>
          <MerchandisingFormSelect
            form={form}
            identifier="experiment.accessMethod"
            labelId="bannersDomain.bannersForm.form.section.content.experiment.method.label"
            options={accessMethodOptions}
            defaultValue={experimentMethod}
            onChange={({ value }) => setValue('experiment.accessMethod', value)}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      <div css={footnoteWrapper}>
        <Text css={footnoteStyles}>{footnote}</Text>
      </div>
    </MerchandisingFormSection>
  )
}
